import React from 'react';
import { matchActionTag } from '~/utils/actionTagConfig';
import { TagAction } from '~/pages/CharacterSheet/types';
import { ActionTag } from '~/widgets/ActionTag/ActionTag';
import { Badge } from '~/widgets/Badge/Badge';

export interface TagRenderContext {
  currentHp: number;
  currentResilience: number;
  itemName: string;
  sourceType?: 'Item' | 'Ability';
  onTagAction: (action: TagAction) => void;
}

export const renderTag = (
  query: string,
  index: number,
  context: TagRenderContext
): React.ReactElement => {
  // Try to match as an action tag
  const match = matchActionTag(query, context);

  if (match) {
    const { actionType, value, style, canAfford, resourceName } = match;

    // Build appropriate title message
    const action = style === 'positive' ? 'gain' : 'lose';
    const titleMessage = canAfford
      ? `Click to ${action} ${value} ${resourceName}`
      : `Insufficient ${resourceName}: ${context[resourceName === 'Health' ? 'currentHp' : 'currentResilience']} (Need ${value})`;

    return (
      <ActionTag
        key={index}
        text={query}
        actionType={actionType}
        value={value}
        canAfford={canAfford}
        onClick={() => context.onTagAction({
          type: actionType,
          value,
          sourceName: context.itemName,
          sourceType: context.sourceType,
        })}
        title={titleMessage}
      />
    );
  }

  // Not an action tag, render as plain badge
  return <Badge key={index} variant="inline">{query}</Badge>;
};
